export default Object.freeze({
  common: {
    subject: {
      Aborto: "Aborto",
      Género: "Gênero",
      Eutanasia: "Eutanásia",
      Salud: "Saúde",
      Familia: "Família",
      Violencia: "Violência",
      Educación: "Educação",
      Vida: "Vida",
      Libertad: "Liberdade",
      Otros: "Outros",
    },
  },
  project: {
    projectType: {
      iniciativa: "Iniciativa",
      dictamen: "Parecer",
      sentencia: "Sentença",
    },
    position: {
      Registro: "Registro",
      Comisiones: "Comissões",
      Pleno: "Plenário",
      "En revisora": "Em revisão",
      Ejecutivo: "Executivo",
      Retirado: "Retirado",
      Desechado: "Descartado",
      "Caducidad legislativa": "Caducidade legislativa",
      Publicado: "Publicado",
      "En vigor": "Em vigor",
      Dictaminado: "Decidido",
      "Sala/Pleno": "Sala/Plenário",
      Resuelto: "Resolvido",
    },
    type: {
      Abroga: "Revoga",
      Deroga: "Derruba",
      "Deroga y Reforma": "Derruba e Reforma",
      Exhorto: "Exortação",
      "Nueva Ley": "Nova Lei",
      Reforma: "Reforma",
      Reserva: "Reserva",
      Solicitud: "Solicitação",
      Otro: "Outro",
      "Acción inconstitucionalidad": "Ação de inconstitucionalidade",
      "Amparo directo": "Amparo direto",
      "Amparo directo en revisión": "Amparo direto em revisão",
      "Amparo en revisão": "Amparo em revisão",
      "Controversia constitucional": "Controvérsia constitucional",
    },
  },
  publication: {
    media: {
      Fotografia: "Fotografia",
      Periodico: "Jornal",
      Radio: "Rádio",
      "Red Social": "Rede Social",
      Sitio: "Website",
      TV: "TV",
      Video: "Vídeo",
      Testimonio: "Depoimento",
      "Propuesta de Governo": "Proposta de Governo",
      Otro: "Outro",
    },
    status: {
      Original: "Original",
      Cambiado: "Alterado",
      Excluido: "Excluído",
    },
  },
  voting: {
    votingType: {
      discusion: "Discussão",
      votacion: "Votação",
      votacion_scjn: "Votação (SCJN)",
    },
    status: {
      "En estudio": "Em estudo",
      Finalizado: "Finalizado",
    },
    result: {
      Pendente: "Pendente",
      "No aprobado": "Não aprovado",
      Aprobado: "Aprovado",
    },
    direction: {
      Validez: "Validade",
      Invalidez: "Invalidade",
      Sobreseimiento: "Arquivamento",
    },
    type: {
      Nominal: "Nominal",
      Económica: "Econômica",
      "Por cédula": "Por cédula",
      Provisional: "Provisória",
    },
  },
  vote: {
    option: {
      "A favor": "A favor",
      "En contra": "Contra",
      Abstencion: "Abstenção",
      Ausente: "Ausente",
      null: "Sem informação",
      undefined: "Sem informação",
      "": "Sem informação",
    },
  },
  label: {
    list: "Listagem",
    projects: "Projetos",
    dictamen: "Parecer",
    politicians: "Políticos",
    politician: "Político",
    votings: "Votações",
    votes: "Votos",
    vote: "Voto",
    publications: "Publicações",
    accounts: "Estabelecimentos",
    account: "Estabelecimento",
    comissions: "Comissões",
    comission: "Comissão",
    plenos: "Plenários",
    period: "Período",
    filters: "Filtros",
    projectType: "Tipo de projeto",
    votingType: "Tipo de votação",
    alias: "Alias",
    position: "Posição",
    subject: "Tema",
    subsubject: "Subtema",
    type: "Tipo",
    otherType: "Outro tipo",
    source: "Origem",
    party: "Partido",
    electionType: "Tipo de eleição",
    electoralDistrict: "Distrito eleitoral",
    iniciativas: "Iniciativas",
    adherencias: "Apoios",
    votaciones: "Votações",
    menciones: "Menções",
    comision: "Comissão",
    comisiones: "Comissões",
    curricula: "Currículos",
    licencias: "Licenças",
    asistencias: "Presenças",
    generatedProjects: "Projetos Gerados",
    inicialistas: "Promotores",
    adherentes: "Apoiadores",
    datePresentation: "Data de apresentação",
    dateResolution: "Data de resolução",
    media: "Meio",
    status: "Status",
    publicationTitle: "Título da Publicação",
    publicationDrive: "Publicação (Drive)",
    date: "Data",
    dateInicial: "Data inicial",
    dateFinal: "Data final",
    webSource: "Fonte (web)",
    author_reporter: "Autor/Repórter",
    mentioned: "Contato/Político mencionado",
    comments: "Comentários",
    description: "Descrição",
    observations: "Observações",
    details: "Detalhes",
    relations: "Relações",
    relationships: "Relações",
    rapporteur: "Relator",
    documents: "Documentos",
    laws: "Leis",
    legislationAndLaws: "Legislação e Leis",
    inFavor: "A favor",
    against: "Contra",
    abstention: "Abstenção",
    absent: "Ausente",
    votingText: "Texto da Votação (PDF)",
    votingDrive: "Votação (Drive)",
    votingOficial: "Oficial do SCJN",
    votingFinal: "Sentença final",
    projectDirection: "Sentido do projeto",
    summary: "Sumário",
    isSubstitute: "É suplente?",
    name: "Nome",
    project: "Projeto",
    result: "Resultado",
    privacyAndTerms: "Privacidade e condições",
    verifyPhone: "Verificar telefone",
    state: "Estado",
    action: "Ação",
    true: "Sim",
    false: "Não",
    plenary: "PLENÁRIO",
    religiousInfo: "Informação religiosa",
    additionalInfo: "Informação complementar",
    owner: "Proprietário",
    substitute: "Suplente",
    sex: "Sexo",
    firstName: "Nome(s)",
    lastName: "Sobrenome(s)",
    post: "Cargo",
    mainPost: "Cargo principal",
    birthdate: "Data de nascimento",
    age: "Idade",
    kids: "Quantidade de filhos",
    quotas: "Por cuotas",
    hobby: "Hobby/passatempo",
    otherHobby: "Outro hobby",
    professed: "Religião professada",
    otherProfessed: "Outra religião professada",
    practiced: "Religião praticada",
    otherPracticed: "Outra religião praticada",
    parish: "Paróquia",
    diocese: "Diocese",
    denomination: "Denominação religiosa",
    site: "Site",
    facebook: "Facebook",
    instagram: "Instagram",
    youtube: "Youtube",
    twitter: "Twitter",
    otherLink: "Outro link",
    extension: "Ramal",
    workEmail: "E-mail de trabalho",
    otherEmail: "E-mail pessoal",
    curriculum: "Currículo (Link)",
    privateAddress: "Endereço particular",
    zipCode: "CEP",
    country: "País",
    town: "Cidade",
    colony: "Bairro",
    street: "Rua",
    externalNumber: "Num exterior",
    internalNumber: "Num interior",
    lot: "Lote",
    block: "Quadra",
    city: "Município",
    phone: "Telefone",
    code: "Código",
    email: "E-mail",
    password: "Senha",
    theme: "Tema",
    locale: "Idioma",
    search: "Busca",
    maritalStatus: "Estado civil",
    seeMore: "Ver mais",
    seeLess: "Ver menos",
    requestChanges: "Solicitar ajustes",
    message: "Mensagem",
    total: "Total",
    lists: "Listados",
    evaluation: "Avaliação",
    votingEvaluation: "Avaliação geral dos votos",
    evaluations: "Avaliações",
    evaluationsGeneral: "Avaliação geral",
    evaluationsPerSubject: "Avaliações por temas",
    votingEvaluationsPerSubject: "Avaliações dos votos por temas",
    driveDocument: "Documento (Drive)",
    linkWeb: "Link (Web)",
    all: "Todos",
    unavailable: "Indisponível",
    active: "Ativo",
    inactive: "Inativo",
    headers: "Cabeçalhos",
    legislation: "Legislação",
    comisionInitialist: "Comissão inicialista",
    dictamenIniciativa: "Parecer da iniciativa",
    sentenciaFinal: "Sentença final",
    proyecto1: "Projeto 1",
    proyecto2: "Projeto 2",
    dictamenProject: "Parecer do projeto",
    categoria: "Categoria",
    actual: "Atual",
    percentagePeriod: "Porcentagem do período",
  },
  description: {
    privacyAndTerms:
      "Quando você usa nossos serviços, você nos confia suas informações.\nTalvez alguma informação presente neste site não esteja atualizada.\nRequisito de idade: 14 anos ou mais.",
    requestChanges: "Envie-nos uma mensagem solicitando ajustes. Obrigado!",
    searchGuide: "Tente fazer uma busca ou filtrar registros.",
    chatAi: "Link do Chat IA exclusivo (em teste)",
    noAuthorizationMessage:
      "Parece que o acesso ao aplicativo ainda não foi concedido. Por favor, fale com o seu administrador para obter acesso.",
    noDataAvailable: "Não há dados disponíveis",
    pleaseFilterOrSearch: "Por favor, use os filtros ou a barra de busca para refinar os resultados.",
  },
  alert: {
    signIn: "Preencha o seguinte formulário para acessar a plataforma.",
    insertCode:
      "Por favor, insira abaixo o código para verificar seu telefone.",
    receiveCode: "Para receber um código, o Captcha deve ser resolvido.",
    selectState: "Por favor, escolha um estado.",
  },
  text: {
    dateFormat: "DD/MM/AAAA",
  },
  select: {
    sex: {
      male: "Masculino",
      female: "Feminino",
    },
    theme: {
      light: "Claro",
      dark: "Escuro",
    },
    state: "Estado",
  },
  button: {
    signIn: "Entrar com {provider}",
    signOut: "Sair",
    language: "Português",
    confirm: "Confirmar",
    update: "Atualizar",
    agree: "Aceitar",
    disagree: "Rejeitar",
    cancel: "Cancelar",
    search: "Buscar",
    filter: "Filtrar",
    seeList: "Ver listagem",
    seeFilters: "Ver filtros",
    seeEvaluations: "Ver avaliações",
    close: "Fechar",
    chatAi: "Chat IA (em teste)",
    printView: "Visualização para impressão",
    typeReportTitle: "Digite o título do relatório",
    openFilters: "Abrir filtros",
  },
  hint: {
    account: "Altere o campo e as opções de 'comissão'.",
    projectType: "Altere os campos e as opções de 'posição', 'tipo' e 'leis'.",
  },
  rule: {
    required: "Por favor, preencha este campo.",
    invalid: "Valor inválido. Tente outro valor.",
    isNumber: "Utilize apenas números.",
    isPhoneNumber: "Os números de telefone devem ser como +5255XXXXXXXX",
    isDate: "Por favor, preencha com uma data válida.",
    isCode: "Código inválido.",
    one: "Por favor, preencha pelo menos um campo.",
    emailIsValid: "Por favor, preencha com um e-mail válido.",
    passwordHasValidCharacters: "A senha contém caracteres inválidos: {chars}.",
    passwordHasValidLength: "A senha deve ter pelo menos {length} caracteres.",
    passwordHasLowerCase: "A senha deve ter pelo menos uma letra minúscula.",
    passwordHasUpperCase: "A senha deve ter pelo menos uma letra maiúscula.",
    passwordHasNumber: "A senha deve ter pelo menos um número.",
    passwordHasSpecialCharacter:
      "A senha deve ter pelo menos um caractere especial (@, $, !, %, *, #, ?, &, <, +, _).",
    credentialsAreNotWrong:
      "As credenciais estão incorretas. Verifique se você digitou seu e-mail e senha corretamente.",
  },
  Masculino: "Masculino",
  Femenino: "Feminino",
  Feminino: "Feminino",
  Soltero: "Solteiro",
  Casado: "Casado",
  Divorciado: "Divorciado",
  Viudo: "Viúvo",
  "Unión libre": "União estável",
  Soltera: "Solteira",
  Casada: "Casada",
  Divorciada: "Divorciada",
  Viuda: "Viúva",
});
